// Standard "123 Main St" form: a leading house number.
const HOUSE_NUMBER = /^\d+\S*\s+\S+/;
// PO Box - no street number at all, but a valid mailing address.
const PO_BOX = /^p\.?\s*o\.?\s*box\s+\S+/i;
// USPS rural route ("RR 2 Box 152", "HC 65 Box 22").
const RURAL_ROUTE = /^(rr|hc)\s*#?\d+/i;
// Township grid addresses ("N65W25055 Colgate Rd", "W2340 County Rd F") -
// standard in Wisconsin's Milwaukee/Waukesha-area municipalities.
const GRID_ADDRESS = /^[nsew]\d+([nsew]\d+)?\s+\S+/i;
// Written-out house number ("One Microsoft Way", "Two Prudential Plaza").
const WRITTEN_NUMBER_STREET =
  /^(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\s+\S+\s+\S+/i;
// Bare "#" used as the house-number marker ("#5 Main St") - strip it and
// re-test for a house number, rather than treating "#5" as a unit token.
const HASH_PREFIX = /^#\s*/;
// Unit/apartment prefix before the real house number ("Apt 4B, 55 Elm St",
// "Unit 3, 400 Oak St") - strip the unit token and re-test the remainder.
const UNIT_WORD_PREFIX = /^(apt\.?|unit|suite|ste\.?)\s+\S+\s*,?\s*/i;

/**
 * True if `value` reads as a street address rather than just a city/state/
 * ZIP. Used to stop the quick-add "Add a Prospect's Property" flow from
 * creating a property with no actual street address - a bare city isn't a
 * property Gitcha can match or report on.
 *
 * Deliberately narrow: it recognizes the common US address shapes above but
 * doesn't attempt full geocoding-grade validation, so some valid formats
 * (e.g. a house number written after the street name, as in some Puerto
 * Rico addresses) still won't match. Callers should skip this check
 * entirely once an address has already been confirmed some other way (e.g.
 * picked from autocomplete), rather than relying on this to accept it.
 */
export function looksLikeStreetAddress(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return false;
  if (HOUSE_NUMBER.test(trimmed)) return true;
  if (PO_BOX.test(trimmed)) return true;
  if (RURAL_ROUTE.test(trimmed)) return true;
  if (GRID_ADDRESS.test(trimmed)) return true;
  if (WRITTEN_NUMBER_STREET.test(trimmed)) return true;

  const withoutPrefix = HASH_PREFIX.test(trimmed)
    ? trimmed.replace(HASH_PREFIX, "")
    : trimmed.replace(UNIT_WORD_PREFIX, "");
  return withoutPrefix !== trimmed && HOUSE_NUMBER.test(withoutPrefix);
}
